import React, { useState } from 'react';

const EmissionTab = () => {
  
  return (
    <div className="descrt-component">
      <div className="row">
        <div className="col-12">
          <p className="f-20 text-black mb-3">Issue info</p>
          <div className="invst-info-form" style={{ height: 'auto' }}>
            <div className="row">
              <div className="col-12 col-md-6 col-lg-4 mb-4">
                <p className="f-13">Start date :</p>
                <p className="f-14 text-black">2024.09.11 15:30</p>
              </div>
              <div className="col-12 col-md-6 col-lg-4 mb-4">
                <p className="f-13">End date :</p>
                <p className="f-14 text-black">2024.09.11 15:30</p>
              </div>
              <div className="col-12 col-md-6 col-lg-4 mb-4">
                <p className="f-13">Number of shares :</p>
                <p className="f-14 text-black">20</p>
              </div>
              <div className="col-12 col-md-6 col-lg-4 mb-4">
                <p className="f-13">Price per share :</p>
                <p className="f-14 text-black">20</p>
              </div>
              <div className="col-12 col-md-6 col-lg-4 mb-4">
                <p className="f-13">Minimum investment :</p>
                <p className="f-14 text-black">NOK 4,232.72</p>
              </div>
              <div className="col-12 col-md-6 col-lg-4 mb-4">
                <p className="f-13">Maximum investment :</p>
                <p className="f-14 text-black">NOK 4,232.72</p>
              </div>
              <div className="col-12 col-md-6 col-lg-4 mb-4">
                <p className="f-13">Value before issue*:</p>
                <p className="f-14 text-black">NOK 4,232.72</p>
              </div>
            </div>
            <hr />
            <h4 className="f-20 text-black">After Issue</h4>
            <div className="table-main">
              <table className="w-100">
                <thead>
                  <tr>
                    <th>
                      <span className="f-13 text-black">After issue</span>
                    </th>
                    <th>
                      <span className="f-13 text-black">Minimum limit</span>
                    </th>
                    <th>
                      <span className="f-13 text-black">Maximum limit</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <span className="f-13">Raised capital</span>
                    </td>
                    <td>
                      <span className="f-13">NOK 6,501,457.92</span>
                    </td>
                    <td>
                      <span className="f-13">NOK 6,501,457.92</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span className="f-13">Share of company sold</span>
                    </td>
                    <td>
                      <span className="f-13">8%</span>
                    </td>
                    <td>
                      <span className="f-13">10%</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span className="f-13">Raised capital</span>
                    </td>
                    <td>
                      <span className="f-13">92</span>
                    </td>
                    <td>
                      <span className="f-13"> 6,501</span>
                    </td>
                  </tr>
                </tbody>{' '}
              </table>
            </div>
          </div>
          <h4 className='f-20 pt-4'>Self-Report</h4>
          <p className='f-13'>As of the present moment, our company is actively seeking additional financial support to fuel our growth and expansion initiatives. The need for capital arises from our strategic vision to innovate and scale our operations, bolster our product development, enhance our market reach, and invest in cutting-edge technologies. This infusion of funds will not only strengthen our financial position but also enable us to seize emerging opportunities within our industry and meet increasing customer demands. We are confident that with the right investment, we can accelerate our trajectory, achieve significant milestones, and ultimately deliver greater value to our stakeholders while solidifying our position as a market leader.</p>
        </div>
      </div>
    </div>
  );
};

export default EmissionTab;
